import { createWebHistory, createRouter } from "vue-router";
import { routes } from "./routes";
import store from "./store";
import { useToast } from "vue-toastification";

const toast = useToast();

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const loggedIn = store.state.auth.status.loggedIn;
  const userInfo = store.state.auth.user;

  // Verificar si la ruta existe
  if (!to.matched.length) {
    return { path: "/" };
  }

  if (to.meta.requiresAuth && !loggedIn) {
    return {
      path: "/auth/login",
      query: { redirect: to.fullPath },
    };
  } else if (to.meta.guestOnly && loggedIn) {
    return {
      path: "/",
    };
  } else if (
    loggedIn &&
    to.meta.roles &&
    !to.meta.roles.some((rol) => userInfo?.roles.includes(rol))
  ) {
    toast.warning("No tienes permiso para acceder a este módulo");
    return {
      path: "/",
    };
  }
});

export { router };
